/**
 * @file Builds a fake Upload customRequest that accepts a file without sending it anywhere.
 */
import type { UploadProps } from "antd";
import type { RcFile } from "antd/es/upload";

import { wait } from "@api";

const NEXT_TICK_MS = 0;
const SUCCESS_DELAY_MS = 25;
const SUCCESS_BODY = "ok";

type Callback = (file: RcFile) => void;

// Accepts each selected file without an upload, so the folder button can
// collect the files before the form sends them.
/**
 * Builds the customRequest that hands the selected file to the callback and then
 * reports it as a successful upload.
 */
const getDummyRequest = (callback: Callback): UploadProps["customRequest"] => {
  /**
   * Hands the selected file to the callback and reports it as a successful upload.
   */
  const customRequest: UploadProps["customRequest"] = ({ file, onSuccess }) => {
    setTimeout(async () => {
      callback(file as RcFile);

      await wait(SUCCESS_DELAY_MS);
      onSuccess(SUCCESS_BODY);
    }, NEXT_TICK_MS);
  };

  return customRequest;
};

export default getDummyRequest;
